import React from 'react';
import { Container } from 'react-bootstrap';
import ElectionIssues from '~/helpers/constants/ElectionIssues';

import { PopGrid } from '@australiangreens/components';
/**
 * Component for the 2025 TAS "Why Vote Green" section.
 */
export const TAS25WVG = () => (
  <Container>
    <div className="container pt-1">
      <p>Both the Liberals and Labor are focused on building a billion-dollar stadium in Hobart.</p>
      <p>Meanwhile, Tasmanians are struggling to find a home, waiting hours for ambulances, and falling behind on their bills.</p>
      <p>Forests are still being logged, and salmon farming corporations are polluting our oceans and our beaches.</p>
      <p>It&apos;s no wonder people are fed up.</p>
      <p><strong>Vote 1 Greens to stop the stadium, invest in health and housing, and protect our environment.</strong></p>

      <PopGrid tiles={ElectionIssues.tas25} rowSize={2} />
    </div>
  </Container>
);

export default TAS25WVG;
